// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3N69_","title":"ClientReferral_title__25jTu","itemText":"ClientReferral_itemText__1w4Fu"};